import {
  addDays,
  addMinutes,
  endOfDay,
  format,
  isAfter,
  isBefore,
  isSameSecond,
  isValid,
  parseISO,
  startOfDay,
  startOfMinute,
  subDays,
  subSeconds,
} from "date-fns";

export default function holidayReducer(holiday, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "start": {
      if (action.fullDay) {
        return {
          ...holiday,
          [action.type]: isValid(action.value)
            ? format(startOfDay(action.value), "yyyy-MM-dd HH:mm:ss")
            : holiday[action.type],
        };
      } else {
        return {
          ...holiday,
          [action.type]: isValid(action.value)
            ? format(startOfMinute(action.value), "yyyy-MM-dd HH:mm:ss")
            : holiday[action.type],
        };
      }
    }
    case "end": {
      if (action.fullDay) {
        return {
          ...holiday,
          [action.type]: isValid(action.value)
            ? format(startOfDay(addDays(action.value, 1)), "yyyy-MM-dd HH:mm:ss")
            : holiday[action.type],
        };
      } else {
        return {
          ...holiday,
          [action.type]: isValid(action.value)
            ? format(startOfMinute(action.value), "yyyy-MM-dd HH:mm:ss")
            : holiday[action.type],
        };
      }
    }
    case "fullDay": {
      if (action.fullDay) {
        return {
          ...holiday,
          start: format(startOfDay(holiday.start), "yyyy-MM-dd HH:mm:ss"),
          end: format(endOfDay(holiday.end), "yyyy-MM-dd HH:mm:ss"),
        };
      } else {
        return {
          ...holiday,
          end: format(
            isSameSecond(endOfDay(holiday.end), holiday.end)
              ? endOfDay(holiday.end)
              : endOfDay(subDays(holiday.end, 1)),
            "yyyy-MM-dd HH:mm:ss",
          ),
        };
      }
    }

    case "startBlur": {
      if (isAfter(action.value ? holiday.start : action.event, subSeconds(holiday.end, 1))) {
        if (action.fullDay) {
          return {
            ...holiday,
            end: isValid(action.value ? parseISO(holiday.start) : action.event)
              ? format(startOfDay(addDays(action.value ? holiday.start : action.event, 1)), "yyyy-MM-dd HH:mm:ss")
              : action.value
                ? holiday.start
                : action.event,
          };
        } else {
          return {
            ...holiday,
            end: isValid(action.value ? parseISO(holiday.start) : action.event)
              ? format(
                  startOfMinute(addMinutes(action.value ? holiday.start : action.event, 60)),
                  "yyyy-MM-dd HH:mm:ss",
                )
              : action.value
                ? holiday.start
                : action.event,
          };
        }
      }
      return holiday;
    }
    case "endBlur": {
      if (isBefore(subSeconds(action.value ? holiday.end : action.event, 1), holiday.start)) {
        if (action.fullDay) {
          return {
            ...holiday,
            end: isValid(parseISO(holiday.start))
              ? format(startOfDay(addDays(holiday.start, 1)), "yyyy-MM-dd HH:mm:ss")
              : holiday.start,
          };
        } else {
          return {
            ...holiday,
            end: isValid(parseISO(holiday.start))
              ? format(startOfMinute(addMinutes(holiday.start, 60)), "yyyy-MM-dd HH:mm:ss")
              : holiday.start,
          };
        }
      }
      return holiday;
    }

    default:
      return { ...holiday, [action.type]: action.value };
  }
}
